export default "__VITE_ASSET__237e4c1f__"